import { RootState } from "app/store";
import { dossierAdapter } from "./state";

const selectIsLoadingDossiers = (state: RootState) =>
    state.cases.caseManagement.isLoadingDossiers ?? false;
const selectErrorLoadingDossiers = (state: RootState) =>
    state.cases.caseManagement.errorLoadingDossiers;

const { selectAll: selectAllDossiers } = dossierAdapter.getSelectors(
    (state: RootState) => state.cases.caseManagement.dossiers,
);

const selectTotalDossiers = (state: RootState) =>
    state.cases.caseManagement.totalDossiers;

export const dossierOverviewSelectors = {
    selectAllDossiers,
    selectTotalDossiers,
    selectIsLoadingDossiers,
    selectErrorLoadingDossiers,
};
